import Component from '@glimmer/component';

import clipboard from 'ember-cli-clipboard/modifiers/clipboard';
import { t } from 'ember-intl';

import Button from 'umg-ember-backend/components/ui/button';
import ENV from 'umg-ember-backend/config/environment';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import AssetInformation from '../asset-information';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class AssetToolsSamplingComponent extends Component {
  // Getter and setter
  get samplingUrlDe() {
    return `${ENV.mediaserviceHost}/de/video?id=${this.args.asset.id}`;
  }

  get samplingUrlEn() {
    return `${ENV.mediaserviceHost}/en/video?id=${this.args.asset.id}`;
  }

  // Template
  <template>
    <div class={{bem}} ...attributes>
      <AssetInformation
        @asset={{@asset}}
        @copySuccess={{@copySuccess}}
        @copyError={{@copyError}}
      />

      <label for='sampling-url'>
        {{t 'asset_tools.sampling.results.sampling_url_de'}}
      </label>
      <div class={{bem 'result'}}>
        <input
          value={{this.samplingUrlDe}}
          class={{bem 'input'}}
          data-test-asset-tool-sampling-input
          id='sampling-url-de'
          readonly
        />

        <Button
          @label={{t 'asset_tools.sampling.copy'}}
          class={{bem 'copy'}}
          {{clipboard
            text=this.samplingUrlDe
            onSuccess=@copySuccess
            onError=@copyError
          }}
        />
      </div>
      <label for='sampling-url'>
        {{t 'asset_tools.sampling.results.sampling_url_en'}}
      </label>
      <div class={{bem 'result'}}>
        <input
          value={{this.samplingUrlEn}}
          class={{bem 'input'}}
          data-test-asset-tool-sampling-input
          id='sampling-url-en'
          readonly
        />

        <Button
          @label={{t 'asset_tools.sampling.copy'}}
          class={{bem 'copy'}}
          data-test-asset-tool-sampling-copy-button
          {{clipboard
            text=this.samplingUrlEn
            onSuccess=@copySuccess
            onError=@copyError
          }}
        />
      </div>
    </div>
  </template>
}
